var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "26.982 26 146.037 148",
    viewBox: "26.982 26 146.037 148",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-kq5dfsf71 svg [data-color=\"1\"] {fill: #16163F;}\r\n#comp-kq5dfsf71 svg [data-color=\"2\"] {fill: #DDBBFF;}\r\n#comp-kq5dfsf71 svg [data-color=\"3\"] {fill: #9E3FFD;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#16163F",
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M173.019 168.11a5.89 5.89 0 1 1-11.78 0 5.89 5.89 0 0 1 11.78 0z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16163F",
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M173.019 168.11a5.89 5.89 0 1 1-11.78 0 5.89 5.89 0 0 1 11.78 0z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7EB",
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M153.608 59.374v93.252H60.356V59.374h93.252z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E3FFD",
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M92.749 26v65.767H26.982V26h65.767z",
    "data-color": 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon3);
export default __webpack_public_path__ + "static/media/ServiceIcon3.5ff0e1394155d2c0d1719e8f5899199d.svg";
export { ForwardRef as ReactComponent };